<template>
  <div class="content">
    <div class="tool_top">
      <SearchInput></SearchInput>
    </div>
    <div class="content_body">
      <!-- 详情信息 -->
      <div class="list_content">
        <div class="search_result">
          <div class="result_panel">
            <div class="list_group" v-for="(item, index) in detailData" :key="index">
              <div class="list_group_head">
                <div class="group_head_title">
                  <div class="head_title">
                    <strong class="title_text">{{ item.name }}</strong>
                    <div class="title_label" v-if="detailType == '1' && item.isActive == 1">
                      <img :src="require('@/assets/hotspot.png')" />活跃
                    </div>
                  </div>
                  <div class="head_tags">
                    <el-tag size="small" v-for="(tag, t) in item.tags" :key="'ht_' + t">
                      {{ tagValue(tag) }}
                    </el-tag>
                  </div>
                </div>
                <div class="group_head_tool" v-if="detailType == '1'" style="{position:relative}">
                  平台评分&nbsp;&nbsp;<span class="head_tags_item">{{
                    item.totalScore == 0 ? '--' : item.totalScore > 100 ? 100 : item.totalScore
                  }}</span>
                  <el-button class="tips_icon" slot="reference" size="mini" icon="el-icon-time" circle></el-button>
                  <div class="gred_panel">
                    <div class="list_title">近6个月平台评分情况</div>
                    <div class="list_pnel">
                      <div class="el-statistic" v-for="(item, index) in gredList" :key="'stat_' + index">
                        <div class="head">
                          <span>{{ item.accountMonth }}</span>
                        </div>
                        <div class="con">
                          <span class="number">{{ item.score }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="list_group_body">
                <div class="group_item" v-for="(list, l) in item.list" :key="l">
                  <div class="group_item_filed">{{ list.label }}:</div>
                  <div class="group_item_value">{{ list.value }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card_panel_warp">
        <!-- 基础信息 -->
        <el-card class="box-card" shadow="never" v-if="detailType == '1'">
          <div slot="header" class="clearfix">
            <span>基础信息</span>
          </div>
          <div class="card_body">
            <div class="chart" style="position: relative;">
              <RadarChart ref="radar" :showEmpty="showEmpty"></RadarChart>
              <div class="empty_tips" v-if="showEmpty">暂无数据</div>
            </div>
          </div>
        </el-card>
        <!-- 关系网 -->
        <el-card class="box-card" v-for="(item, i) in chartList" :key="'graph_card_' + i"
          :class="{ 'box-block': i == 0 && detailType != '1' }" shadow="never">
          <div slot="header" class="clearfix">
            <span>{{ item.label }}</span>
          </div>
          <div class="card_body">
            <div class="chart">
              <el-skeleton :rows="8" :loading="item.loading" animated style="width: 100%; height: 100%;" v-show="item.loading"/>
              <GraphChartCombine :ref="'graph_' + detailType + '_' + i" :detailInfo="detailData" v-show="!item.loading"/>
            </div>
          </div>
        </el-card>
        <!-- 关系网 表格信息 -->
        <el-card class="box-card box-block table_card" shadow="never">
          <div slot="header" class="clearfix">
            <span>{{ detailType == '1' ? '掌握资源情况' : detailType == '2' ? '终端关系网信息' : '渠道关系网信息' }}</span>
          </div>
          <div class="card_body">
            <div class="tabs_panel">
              <DetailTables ref="graph_table" :autoHeight="false" />
            </div>
          </div>
        </el-card>
        <!-- 任职信息 -->
        <el-card class="box-card" shadow="never" v-if="detailType == '1'">
          <div slot="header" class="clearfix">
            <span>备案信息</span>
          </div>
          <div class="card_body">
            <div class="timeline_panel">
              <el-timeline>
                <el-timeline-item v-for="(resume, index) in resumeInfo" :key="index" :color="resume.color"
                  :hide-timestamp="false">
                  <div class="timeline_content">
                    <div class="item_head">
                      <div class="item_title">{{ resume.content }}</div>
                      <div class="item_time">{{ resume.timestamp }}</div>
                    </div>
                    <div class="item_body">
                      <div class="detail_group">
                        <div class="group_item" v-for="(item, r) in resume.detail" :key="r">
                          <div class="item_filed">{{ item.field }}：</div>
                          <div class="item_text">{{ item.value }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-card>
        <!-- 变更日志 -->
        <el-card class="box-card" shadow="never" v-if="detailType == '1'">
          <div slot="header" class="clearfix">
            <span>变更记录</span>
          </div>
          <div class="card_body">
            <InfoTable :ref="loggingInfo.id" :tableInfo="loggingInfo" @setParam="setParam"></InfoTable>
          </div>
        </el-card>
        <!-- 采购能力 -->
        <el-card class="box-card" shadow="never" v-if="(detailType == '2' || detailType == '3')">
          <div slot="header" class="clearfix">
            <span>{{ detailType == '2' ? '采购能力' : '人效能力' }}</span>
          </div>
          <div class="card_body">
            <InfoTable :ref="loggingInfo.id" :tableInfo="loggingInfo" @setParam="setParam"></InfoTable>
          </div>
        </el-card>
        <!-- 热门商品 -->
        <el-card class="box-card" shadow="never" v-if="detailType == '2'">
          <div slot="header" class="clearfix">
            <span>热门商品</span>
          </div>
          <div class="card_body" style="overflow: visible; position: relative;">
            <ColumnChart ref="goods"></ColumnChart>
          </div>
        </el-card>
        <!-- 供应链能力 -->
        <el-card class="box-card" shadow="never" v-if="detailType == '3'">
          <div slot="header" class="clearfix">
            <span>供应链(终端资源)能力</span>
          </div>
          <div class="card_body">
            <MapChart ref="supplys"></MapChart>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import SearchInput from './components/search_input.vue';
import InfoTable from './components/infoTable.vue';
import MapChart from './components/charts/mapChart.vue';
import RadarChart from './components/charts/radarChart.vue';
import ColumnChart from './components/charts/columnChart.vue';
import GraphChartCombine from './components/charts/graphChartCombine.vue'
import DetailTables from './detailTables.vue';
import {
  typeFilter,
  getWorkInfo,
  getWorkChange,
  getPurchaseInfo,
  getRankingInfo,
  getSaleInfo,
  getChainData,
  changeNum,
  getScoreList,
  getScoreRadar,
  getStartData,
  getLinkSummary,
  clearCache
} from '@/api/portrait.js'
export default {
  name: 'salesmanDetail',
  components: {
    SearchInput,
    RadarChart,
    ColumnChart,
    MapChart,
    InfoTable,
    GraphChartCombine,
    DetailTables
  },
  data() {
    return {
      detailType: '',
      detailData: [],
      idCard: '',
      limit: 50,
      activeName: '',
      tabList: [],
      baseInfo: [],
      resumeInfo: [],
      graphInfo: {},
      hospitalInfo: {},
      nonHospitalInfo: {},
      loggingInfo: {},
      gredList: [],
      currTableId: '',
      fileList: [],
      showEmpty: false,
      fullscreenLoading: null,
      chartList: []
    };
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.from == "home") {
      sessionStorage.setItem('showBack', 'false')
    }
    next()
  },
  created() {
    this.detailType = this.$route.query.type
    this.detailData = JSON.parse(this.$route.query.data)
    this.idCard = this.detailData[0].idCard || this.detailData[0].damId
    this.chartList = [
      { label: `${this.detailType == '1' ? '人员关系网' : this.detailType == '2' ? '终端服务关系网' : '渠道人员关系网'}`, loading: true },
      { label: `${this.detailType == '1' ? '终端服务关系网' : this.detailType == '2' ? '终端配送关系网' : '渠道配送关系网'}`, loading: true },
      { label: `${this.detailType == '1' ? '销售流向关系网' : this.detailType == '2' ? '终端采购关系网' : '渠道采购关系网'}`, loading: true }
    ]
    // 加载关系网
    this.getLinksData()
    if (this.detailType == '1') {// 经纪人详情
      this.getMonth()
      this.getWorkData()
    }
    this.getWorkTable()
    this.$nextTick(() => {
      this.$refs['graph_table'].initTable()
    })
  },
  methods: {
    openLoading(flag) {
      if (flag) {
        if (!this.fullscreenLoading) {
          this.fullscreenLoading = this.$loading({
            lock: true,
            text: '加载中...',
            background: 'rgba(0, 0, 0, 0.75)',
            customClass: 'map_loading',
            fullscreen: true
          });
        }
      } else {
        this.fullscreenLoading && this.fullscreenLoading.close()
        this.fullscreenLoading = null
      }
    },
    tagValue(row) {
      return typeFilter(row)
    },
    setParam(param, type) {
      this.currTableId = type
      if (type == 'logging_small' || type == 'purchase_small' || type == 'sale_small') {
        this.getWorkTable(param, false)
      }
    },
    // 评分列表/雷达图
    getMonth() {
      var dataArr = [];
      var date = new Date();
      for (var i = 0; i < 6; i++) {
        date.setMonth(date.getMonth() - 1)
        let y = date.getFullYear()
        let m = date.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push({ accountMonth: y + "" + (m), score: '--' });
      }
      // 获取评分列表
      getScoreList({ idCard: this.idCard }).then(res => {
        let data = res.data
        if (data && data.length) {
          let combined = dataArr.map(item => {
            let target = data.find(e => item.accountMonth == e.accountMonth)
            if (target) {
              item.score = target.score
            }
            return item
          })
          this.gredList = combined
        }
      })
      // 获取评分雷达
      getScoreRadar({ idCard: this.idCard }).then(res => {
        let data = res.data
        this.showEmpty = data ? false : true
        if (data) {
          let series = {
            mean: [
              data.avgPlanManageScore,
              data.avgTimeManageScore,
              data.avgUseCountScore,
              data.avgCustManageScore,
              data.avgQualityManageScore
            ],
            power: [
              data.planManageScore,
              data.timeManageScore,
              data.useCountScore,
              data.custManageScore,
              data.qualityManageScore
            ]
          }
          this.$nextTick(() => {
            this.$refs.radar.setOption(series)
          })
        }
      })
    },
    // 获取关系网
    getLinksData() {
      this.$nextTick(() => {
        for (var i = 0; i < this.chartList.length; i++) {
          (() => {
            if (this.detailType == '1') {
              let param = { damId: this.idCard, linkType: (i + 1) }
              getLinkSummary(param).then(res => {
                this.$nextTick(() => {
                  this.$refs["graph_" + this.detailType + '_' + (param.linkType - 1)][0].chartName = this.detailType + '-' + param.linkType
                  this.$refs["graph_" + this.detailType + '_' + (param.linkType - 1)][0].setOption(res.data)
                  this.chartList[param.linkType - 1].loading = false
                })
              })
            } else if (this.detailType == '2') {
              let param = { damId: this.idCard, linkType: (i + 4) }
              getLinkSummary(param).then(res => {
                this.$nextTick(() => {
                  this.$refs["graph_" + this.detailType + '_' + (param.linkType - 4)][0].chartName = this.detailType + '-' + param.linkType
                  this.$refs["graph_" + this.detailType + '_' + (param.linkType - 4)][0].setOption(res.data)
                  this.chartList[param.linkType - 4].loading = false
                })
              })
            } else if (this.detailType == '3') {
              let param = { damId: this.idCard, linkType: (i + 7) }
              getLinkSummary(param).then(res => {
                this.$nextTick(() => {
                  this.$refs["graph_" + this.detailType + '_' + (param.linkType - 7)][0].chartName = this.detailType + '-' + param.linkType
                  this.$refs["graph_" + this.detailType + '_' + (param.linkType - 7)][0].setOption(res.data)
                  this.chartList[param.linkType - 7].loading = false
                })
              })
            } else {
              return
            }
          })()
        }
      })
      if (this.detailType == '2') {
        // 获取热销商品
        getRankingInfo({ damId: this.idCard }).then(res => {
          this.$refs.goods.chartName = 'goods_detail'
          this.$refs.goods.setOption(res.data)
        })
      } else if (this.detailType == '3') {
        // 供应能力
        getChainData({ damId: this.idCard }).then(res => {
          this.$refs.supplys.setOption(res.data)
        })
      }
    },
    // 获取工作履历
    getWorkData() {
      let param = {
        idCard: this.idCard
      }
      getWorkInfo(param).then(res => {
        let data = res.data
        if (data.length > 0) {
          data.map(item => {
            this.resumeInfo.push({
              content: item.enterpriseName,
              timestamp: item.entryDate + '-' + item.dimissionDate,
              detail: [
                { field: '区域', value: item.region },
                { field: '部门', value: item.deptName },
              ],
              color: '#4FA1A4'
            })
          })
        }
      })
    },
    // 获取变更信息
    getWorkTable(param, init) {
      let isInit = init === undefined ? true : init
      let params = param === undefined ? {} : param
      if (isInit) {
        params.pageIndex = 1;
        params.pageSize = this.limit
      }
      let method = null
      if (this.detailType == '1') {
        // 获取变更信息
        params.idCard = this.idCard
        method = getWorkChange(params)
      } else if (this.detailType == '2') {
        // 获取采购能力数据
        params.damId = this.idCard
        method = getPurchaseInfo(params)
      } else if (this.detailType == '3') {
        // 获取人效能力
        params.damId = this.idCard
        method = getSaleInfo(params)
      }
      method.then(res => {
        let data = res.data.records ? res.data.records : []
        this.loggingInfo = {
          curr: res.data.pageIndex,
          limit: res.data.pageSize,
          count: res.data.totalRows,
          page: res.data.totalPages,
          data: data
        }
        if (this.detailType == '1') {
          this.loggingInfo.id = 'logging_small'
          this.loggingInfo.head = [
            { label: '变更日期', field: 'changeTime' },
            { label: '变更范围', field: 'changType' },
            { label: '变更前', field: 'preValue' },
            { label: '变更后', field: 'currValue', width: 200 }
          ]
        } else if (this.detailType == '2') {
          this.loggingInfo.id = 'purchase_small'
          this.loggingInfo.head = [
            { label: '年份', field: 'year' },
            { label: '药企数', field: 'enterprises' },
            { label: '采购总数量', field: 'purchaseNum', minWidth: 100, align: 'right' },
            { label: '采购平均数量', field: 'avgPurchaseNum', minWidth: 100, align: 'right' }
          ]
          if (data.length > 0) {
            this.loggingInfo.data = data.map(item => {
              item.purchaseNum = item.purchaseQty ? changeNum(item.purchaseQty) : '--'
              item.avgPurchaseNum = item.avgPurchaseQty ? changeNum(item.avgPurchaseQty) : '--'
              return item
            })
          }
        } else if (this.detailType == '3') {
          this.loggingInfo.id = 'sale_small'
          this.loggingInfo.head = [
            { label: '年份', field: 'year' },
            { label: '备案人员姓名', field: 'staffName' },
            { label: '总销售额', field: 'totalAmt', width: 120, align: 'right' }
          ]
          if (data.length > 0) {
            this.loggingInfo.data = data.map(item => {
              item.totalAmt = item.saleAmt ? changeNum(item.saleAmt, 2) + '元' : '--'
              return item
            })
          }
        }
      })
    },
    // 清除缓存数据
    clearCacheData() {
      clearCache().then(res => {
        this.$message({
          message: '清除缓存成功',
          type: 'success'
        })
      })
    }
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/style/portrait.less";

/deep/.tool_top {
  position: relative;

  .clear_btn {
    position: absolute;
    top: 50%;
    left: 94px;
    transform: translateY(-50%);
  }
}

/deep/.list_content .search_result .result_panel .list_group {
  &:hover {
    background-color: #fff;
  }
}

.card_panel_warp {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  text-align: left;
  margin-bottom: 4px;

  /deep/.el-card {
    &.box-card {
      width: calc(50% - 8px);
      height: 370px;
      margin: 4px 0 0 4px;

      .el-card__header {
        font-size: 16px;
        color: #212121;
        line-height: 24px;
        font-weight: 600;
        padding: 11px 15px;
      }

      .el-card__body {
        padding: 15px;
        height: calc(100% - 78px);

        .card_body {
          width: 100%;
          height: 100%;
          font-size: 14px;
          color: #212121;
          overflow: hidden auto;

          .tabs_panel {
            height: 100%;

            .el-tabs {
              height: 100%;

              &__content {
                height: calc(100% - 42px);

                .el-tab-pane,
                .tab_pane_body {
                  height: 100%;
                }
              }
            }
          }

          // 面板列表
          .card_text_item {
            display: flex;
            line-height: 21px;

            .item_filed {
              color: #666;
              width: 88px;
            }

            .item_text {
              &.active {
                color: #4FA1A4;
              }
            }

            +.card_text_item {
              padding-top: 10px;
            }
          }

          // 标签页
          .el-tabs {
            .el-tabs__header {
              margin-bottom: 10px;
            }

            .el-tabs__item {
              width: 96px;
              padding: 0;
              text-align: center;
            }
          }

          // 时间线
          .timeline_panel {
            margin: 0 1px;

            .el-timeline {
              padding-left: 0;
            }

            .timeline_content {
              .item_head {
                margin-bottom: 5px;

                .item_title {
                  line-height: 21px;
                  font-weight: 600;
                  margin-bottom: 5px;
                }

                .item_time {
                  font-size: 12px;
                  color: #666;
                  line-height: 18px;
                  font-weight: 400;
                }
              }

              .item_body {
                .detail_group {
                  display: flex;

                  .group_item {
                    display: flex;

                    .item_filed {
                      color: #999;
                      width: auto;
                    }

                    +.group_item {
                      margin-left: 20px;
                    }
                  }
                }
              }
            }
          }

          .empty_tips {
            font-size: 20px;
            color: #909090;
            position: absolute;
            top: 40%;
            left: 50%;
            transform: translate(-50%, -50%);
          }

          .el-skeleton__p.is-first {
            margin-top: 16px;
          }
        }
      }

      &.box-block {
        width: calc(100% - 10px);

        &.table_card {
          height: 622px;

          .el-card__body {
            padding-top: 5px;

            .card_body {
              .tabs_panel {
                height: calc(100% - 7px);
              }
            }
          }
        }

        &.auto_height {
          height: auto;

          .el-card__body {
            height: auto;

            .card_body {
              height: auto;

              .tabs_panel {
                height: auto;
              }
            }
          }
        }
      }
    }
  }
}

.gred_panel {
  width: 360px;
  position: absolute;
  top: 3.5rem;
  left: -150%;
  background: #fff;
  padding: 5px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .2);
  text-align: left;
  transition: all .3s;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: -16px;
    right: 15px;
    border: 8px solid #ddd;
    border-top-color: transparent;
    border-left-color: transparent;
    border-right-color: transparent;
  }

  &::after {
    right: 14px;
    border-width: 9px;
    border-bottom-color: #fff;
  }

  .list_title {
    color: #212121;
    padding: 0 5px;
    border-bottom: 1px solid #EBEEF5;
    margin-bottom: 5px;
  }

  .list_pnel {
    display: flex;
    justify-content: space-between;

    // align-items: center;
    .el-statistic {
      width: 100%;
      text-align: center;

      .head {
        color: #666;
        font-size: 12px;
        // margin-bottom: 4px;
      }

      .con .number {
        color: #FF5F1F;
        font-size: 14px;
      }
    }
  }
}
</style>
